<template>
    <div>
      <h3 class="font-bold text-gray-700 flex gap-2 items-center">
        <span>Stock Status</span>
        <selection-option-info :info="page_settings.settings.stock_status_info"></selection-option-info>
      </h3>
      <div>
        <span
          class="flex flex-col"
          :class="statusSpanClasses"
          >{{ status }}
            <span class="text-xxxs" v-if="status == 'On Order'">ETA {{ eta }}</span
          >
          </span>
      </div>
    </div>

   
</template>

<script>
import SelectionOptionInfo from "../SelectionOptionInfo.vue";

export default {
  components: {
    SelectionOptionInfo,
  },
  props: {
    warehouses: Array,
    page_settings: Object,
  },
  data() {
    return {
      status_info: `<p>Stock availability and location will affect shipping prices and collection options. We will endeavor to match your shipping address with the cheapest shipping options.</p><p><span class="text-orange-500">On Order</span> items can be ordered now, but with a delay in delivery.</p><p>Please be aware that ETAs may change with the current disruption in global shipping.</p>`,
    };
  },
  computed: {
    
    status() {
      if(this.warehouses.some(w => w.status === 'In Stock'))
      {
        return 'In Stock'
      } else if(this.warehouses.some(w => w.status === 'On Order'))
      {
        return 'On Order'
      } else if(this.warehouses.some(w => w.status === 'Preorder'))
      {
        return 'Preorder'
      } else {
        return 'Out of Stock'
      }
    },
    statusSpanClasses() {
      if(this.status === 'In Stock')
      {
        return 'text-green-500 font-bold'
      } else if(this.status === 'On Order')
      {
        return 'text-orange-500 font-bold'
      } else if(this.status === 'Preorder')
      {
        return 'text-orange-500 font-bold'
      } else {
        return 'text-red-500 font-bold'
      }
    },
    eta() {
      return this.warehouses.filter(w => w.eta).sort((a,b) => {
        if (a < b) {
          return -1;
        } else if (a > b) {
          return 1;
        }
        return 0;
      })?.[0].eta
    }
  }
};
</script>